import type { MBasket } from "@/Models/MBuyPropduct/BuyProduct";
import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "TicketCartDataCache";

export const useTicketCart = () => {
  const [addTicketProduct, setAddTicketProduct] = useState<MBasket[]>(() => {
    //ESTADO INICIAL DESDE LOCALSTORAGE
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  //agregar a la lista de tickets
  const AddTicketCartGo = useCallback(
    (productos: MBasket) => {
      setAddTicketProduct((prev) => {
        //verificamos si el producto ya existe en el carrito
        const exist = prev.find((item) => item.item_id === productos.item_id);
        if (exist) {
          return prev.map((item) =>
            item.item_id === productos.item_id ? productos : item
          );
        }
        return [...prev, productos];
      });
    },
    [addTicketProduct]
  );

  const UpdateQuantity = useCallback(
    (idSku: string, quantity: number) => {
      setAddTicketProduct((prev) =>
        prev.map((item) =>
          item.item_id === idSku ? { ...item, quantity: quantity } : item
        )
      );
    },
    [addTicketProduct]
  );

  const DeleteTicketCart = useCallback(
    (idSku: string) => {
      setAddTicketProduct((prev) =>
        prev.filter((item) => item.item_id !== idSku)
      );
    },
    [addTicketProduct]
  );

  const DeleteClearCart = useCallback(() => {
    setAddTicketProduct([]);
    localStorage.removeItem(STORAGE_KEY);
  }, [addTicketProduct]);

  useEffect(() => {
    //guardamos en el localstorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(addTicketProduct));
  }, [addTicketProduct]);

  return {
    addTicketProduct,
    AddTicketCartGo,
    UpdateQuantity,
    DeleteTicketCart,
    DeleteClearCart,
  };
};
